import { TextField } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLabelsSearch } from '../../../queries'
import { FieldLabelAutocomplete } from '../../FieldLabelAutocomplete'

type LabelEditorFieldProps = {
  disabled?: boolean
  labels?: string[]
  onChange?: (labels?: string[]) => void
}

export const LabelEditorField = ({
  disabled,
  labels: initialLabels,
  onChange,
}: LabelEditorFieldProps) => {
  const { t } = useTranslation('@cibo/landmanager/components/Editors/LabelEditor')
  const [labels, setLabels] = useState<string[]>(initialLabels || [])
  const [query, setQuery] = useState('')
  const [invalid, setInvalid] = useState<string | undefined>(undefined)
  const { data: labelOptions, isLoading: loadingOptions } = useLabelsSearch(query)

  const handleQueryChange = (event: any, value: string) => {
    setQuery(value)
  }

  const handleChange = (event: any, newValue: string[]) => {
    const cleanedLabels = newValue.filter((val: string) => !!val)
    if (cleanedLabels.find(a => a.split(',').length > 1)) {
      setInvalid(t('cannotContainComma'))
    } else {
      setInvalid(undefined)
    }

    onChange && onChange(cleanedLabels)
    setLabels(cleanedLabels)
  }

  return (
    <FieldLabelAutocomplete
      defaultValue={labels}
      value={labels}
      disabled={disabled}
      loading={loadingOptions}
      id="labels"
      freeSolo
      multiple
      options={labelOptions || []}
      getOptionLabel={(option: string) => option}
      onChange={handleChange}
      onInputChange={handleQueryChange}
      getOptionDisabled={(value: string) => !!labels?.includes(value)}
      fullWidth
      size="small"
      renderInput={(params: any) => (
        <TextField
          {...params}
          sx={{ width: '100%' }}
          autoFocus
          fullWidth
          label={null}
          placeholder={t('placeholder')}
          variant="outlined"
          error={invalid}
          helperText={!!invalid ? invalid : query === '' ? ' ' : t('helper')}
        />
      )}
    />
  )
}
